<script>
    import { Route } from 'svelte-router-spa'
    import Footer from '../global/footer.svelte'
    export let currentRoute;
    const params = {}

</script>

<style>
  main {
      display: flex;
      flex-direction: column;
  }
</style>

<main>
 <Route {currentRoute} {params} />


<Footer />
</main>